module.exports = __webpack_public_path__ + "static/media/li.319a7742.svg";